import { useState, useCallback } from "react";
import { request } from "../../httpClient";

type TParams = {
  vehicle_id?: string;
};

export const useVehicleMarkSet = () => {
  const [vehicleMarkSetLoading, setVehicleMarkSetLoading] = useState(false);
  const [vehicleMarkSet, setVehicleMarkSet] = useState([]);

  const getVehicleMarkSet = useCallback(async (params: TParams) => {
    setVehicleMarkSetLoading(true);
    const res = await request({
      path: "vehicle-popular/add",
      method: "POST",
      body: JSON.stringify(params),
    });
    setVehicleMarkSet(res?.data);
    setVehicleMarkSetLoading(false);
    return res?.data;
  }, []);

  return { vehicleMarkSetLoading, vehicleMarkSet, getVehicleMarkSet };
};
